import axios from 'axios';

class modelService {

    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL
        }
    }

    getUsersList() {
        return axios.get(this.state.apiUrl + "home/listUsers", { silent: true })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }

    getCustomersList() {
        return axios.get(this.state.apiUrl + "home/listCustomers", { silent: true })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }

    getUsersListByCompanyId(companyId) {
        return axios.get(this.state.apiUrl + "home/listUsersByCompanyId?companyId="+companyId, { silent: true })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }
    
}
export default modelService;